import { render, staticRenderFns } from "./upTop.vue?vue&type=template&id=cab475de&scoped=true"
import script from "./upTop.vue?vue&type=script&lang=js"
export * from "./upTop.vue?vue&type=script&lang=js"
import style0 from "./upTop.vue?vue&type=style&index=0&id=cab475de&prod&lang=scss&scoped=true"
import style1 from "./upTop.vue?vue&type=style&index=1&id=cab475de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab475de",
  null
  
)

export default component.exports